import { muiOutlinedInputRoot } from "./input.config";
export const MuiOutlinedInput = {
    styleOverrides: {
        root: ({ theme: { palette } }) => (Object.assign({ borderRadius: "8px", "& .MuiOutlinedInput-notchedOutline": {
                padding: "0 10px"
            }, "&:not(.Mui-focused):not(.Mui-error):not(:hover):not(.Mui-disabled) .MuiOutlinedInput-notchedOutline": {
                borderColor: palette.divider
            }, "&:not(.Mui-focused):not(.Mui-error):not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline": {
                borderColor: palette.primary.light
            }, "&:not(.Mui-focused):not(.Mui-error):not(.Mui-disabled) .MuiOutlinedInput-notchedOutline": {
                transition: "border-color 0.3s ease"
            }, "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderWidth: "1px"
            }, "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                borderColor: palette.grey["200"]
            } }, muiOutlinedInputRoot()))
    }
};
//# sourceMappingURL=OutlinedInput.js.map